@if (item().link) {
  <a
    href="{{ item().link }}"
    target="_blank"
    role="menuitem"
    [attr.aria-label]="item().title + ', ' + item().description"
  >
    <ng-container *ngTemplateOutlet="flyOutItemTemplate"></ng-container>
  </a>
}
@if (item().isElevio) {
  <a
    href="#"
    class="elevio__help"
    role="menuitem"
    [attr.aria-label]="item().title + ', ' + item().description"
    (keydown.enter)="elevioElementClick()"
  >
    <ng-container *ngTemplateOutlet="flyOutItemTemplate"></ng-container>
  </a>
}

<ng-template #flyOutItemTemplate>
  <div class="help-sub-menu-flyout-item">
    <div class="help-sub-menu-flyout-item__badge">
      <div class="help-sub-menu-flyout-item__badge-circle" [style.background]="item().badgeColor">
        <ftr-badge [icon]="item().icon" [color]="item().iconColor" [iconAriaHidden]="true"></ftr-badge>
      </div>
    </div>
    <div class="help-sub-menu-flyout-item__detail">
      <div class="help-sub-menu-flyout-item__title">{{ item().title }}</div>
      <div class="help-sub-menu-flyout-item__description">{{ item().description }}</div>
    </div>
  </div>
</ng-template>
